export default "__VITE_ASSET__uWo0Gylc__"